import script from "./BotsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BotsMenu.vue?vue&type=script&setup=true&lang=js"

import "./BotsMenu.vue?vue&type=style&index=0&id=f6bb4264&lang=css"

const __exports__ = script;

export default __exports__